import type { RESOURCE_KEYS } from "./keys";

// eslint-disable-next-line camelcase
export const de_DE: typeof RESOURCE_KEYS = {
	step1: {
		title: "Deine Daten",
		wizardTitle: "Persönliche Daten",
		description: "Bitte fülle das Formular sorgfältig aus und prüfe, ob alle Angaben korrekt sind.",
		submit: "Verifizierungscode anfordern",
		requestCodeError:
			"Der Verifizierungscode konnte nicht angefordert werden. Bitte versuche es erneut. Falls das Problem bestehen bleibt, kontaktiere den Support.",
		agb: {
			// Consent covers the AGB only; the Datenschutzerklärung is merely acknowledged.
			prefix: "Ich stimme den",
			terms: "AGB",
			middle: "zu und wurde auf die",
			privacy: "Datenschutzerklärung",

			// Everything after the last link, so the leading space is deliberate: German closes
			// the sentence with the past participle, English with the bare period.
			suffix: " hingewiesen."
		}
	},
	step2: {
		title: "Registrierung verifizieren",
		wizardTitle: "Verifizierung",
		description:
			"Bitte gib hier deinen Verifizierungscode ein. Der Code wurde dir per E-Mail ({email}) zugeschickt und ist {minutes} Minuten gültig.",
		inputLabel: "Code eingeben",
		resend: "Code erneut senden",
		codeResent: "Bestätigungscode erneut gesendet. Bitte prüfen Sie Ihre E-Mail.",
		loginLink: "Bereits registriert? Jetzt anmelden"
	},
	step3: {
		title: "Passwort festlegen",
		wizardTitle: "Passwort festlegen",
		description: "Lege dein Passwort fest, um dein Konto zu schützen. Achte darauf, dass es möglichst sicher ist.",
		password: "Passwort *",
		confirmPassword: "Passwort wiederholen *",
		submit: "Registrierung abschließen",
		registrationError:
			"Die Registrierung konnte nicht abgeschlossen werden. Bitte versuche es erneut. Falls das Problem bestehen bleibt, kontaktiere den Support.",
		showPassword: "Passwort anzeigen",
		hidePassword: "Passwort verbergen",
		passwordStrength: {
			veryWeak: "Sehr schwach",
			weak: "Schwach",
			good: "Gut",
			strong: "Stark"
		},
		passwordRules: {
			minLength: "Mindestens 12 Zeichen",
			uppercase: "Ein Großbuchstabe",
			lowercase: "Ein Kleinbuchstabe",
			digit: "Eine Zahl",
			specialChar: "Ein Sonderzeichen"
		},
		startOver: "Registrierung neu starten"
	},
	form: {
		firstName: "Vorname",
		lastName: "Nachname",
		email: "Firmen-E-Mail-Adresse"
	},
	legal: {
		termsTitle: "Allgemeine Geschäftsbedingungen",
		privacyTitle: "Datenschutzerklärung",
		print: "Drucken",
		close: "Schließen",
		loading: "Dokument wird geladen …"
	},
	validation: {
		tooSmall: "Dieses Feld ist erforderlich.",
		invalidString: "Ungültige Eingabe.",
		emailInvalid: "Die eingegebene E-Mail-Adresse ist ungültig.",
		emailExists: "Email Adresse ist bereits registriert!",
		emailDomainNotAllowed: "Diese E-Mail-Domain ist nicht zugelassen.",
		emailRequired: "Bitte geben Sie eine E-Mail-Adresse ein.",
		verificationCodeInvalid: "Der Verifizierungscode ist ungültig.",
		codeVerificationLocked: "Du kannst aus Sicherheitsgründen in {time} einen neuen Code eingeben.",
		sessionExpired: "Deine Sitzung ist abgelaufen. Bitte starte die Registrierung erneut.",
		nameTooLong: "Maximal {max} Zeichen.",
		agbUnchecked: "Bitte akzeptieren Sie die AGB.",
		passwordsDontMatch: "Die eingegebenen Passwörter stimmen nicht überein.",
		passwordInvalid:
			"Das Passwort erfüllt nicht die Anforderungen. Es muss mindestens 12 Zeichen lang sein, eine Zahl, einen Großbuchstaben, einen Kleinbuchstaben sowie ein Sonderzeichen enthalten und darf nicht die E-Mail-Adresse enthalten.",
		passwordEmpty: "Bitte geben Sie ein Passwort ein.",
		passwordTooShort: "Das Passwort muss mindestens {min} Zeichen lang sein.",
		passwordTooLong: "Das Passwort darf höchstens {max} Zeichen lang sein.",
		passwordUppercaseRequired: "Das Passwort muss mindestens {count} Großbuchstaben enthalten.",
		passwordLowercaseRequired: "Das Passwort muss mindestens {count} Kleinbuchstaben enthalten.",
		passwordDigitsRequired: "Das Passwort muss mindestens {count} Ziffer(n) enthalten.",
		passwordSpecialCharsRequired: "Das Passwort muss mindestens {count} Sonderzeichen enthalten.",
		passwordMatchesUsername: "Das Passwort darf nicht dem Benutzernamen entsprechen.",
		passwordMatchesEmail: "Das Passwort darf nicht der E-Mail-Adresse entsprechen.",
		passwordContainsEmail: "Das Passwort darf nicht die E-Mail-Adresse enthalten.",
		validationFailed: "Bitte überprüfen Sie Ihre Eingaben.",
		generalError: "Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut."
	},
	wizard: {
		title: "Registrierung",
		back: "Zurück",
		stepOf: "Schritt {current} von {total}",
		footer: {
			alreadyRegistered: "Bereits registriert?",
			loginNow: "Jetzt anmelden"
		}
	}
};
